import { FC } from "react";
import { Typography } from "antd";
import {
  DataWrapper,
  StatisticWrapper,
  StyledText,
  TitleWrapper,
} from "./styled";

interface IProps {
  percent: string;
  symbol: string;
  title: string;
  value: string;
  color: string;
  footer: string;
}

export const StatisticCard: FC<IProps> = ({
  percent,
  symbol,
  title,
  value,
  color,
  footer,
}) => {
  return (
    <StatisticWrapper>
      <TitleWrapper>
        <Typography.Title style={{ margin: 0 }} level={5}>
          {title}
        </Typography.Title>

        <DataWrapper>
          <Typography.Title
            style={{ margin: 0, fontSize: "40px"}}
          >
            {value}
          </Typography.Title>

          <StyledText style={{ color: color }}>
            {symbol}
            {percent}%
          </StyledText>
        </DataWrapper>
      </TitleWrapper>

      <Typography.Title style={{ margin: 0, fontSize: "30px", color: "#6A7695"  }}>
        {footer}
      </Typography.Title>
    </StatisticWrapper>
  );
};
